import { render, staticRenderFns } from "./Helpmanual.vue?vue&type=template&id=89afccec&scoped=true&"
import script from "./Helpmanual.vue?vue&type=script&lang=js&"
export * from "./Helpmanual.vue?vue&type=script&lang=js&"
import style0 from "./Helpmanual.vue?vue&type=style&index=0&id=89afccec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89afccec",
  null
  
)

export default component.exports